var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 26,
    viewBox: "0 0 61 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8158 23.4001C7.4755 23.4001 9.6316 21.654 9.6316 19.5001C9.6316 17.3462 7.4755 15.6001 4.8158 15.6001C2.15611 15.6001 0 17.3462 0 19.5001C0 21.654 2.15611 23.4001 4.8158 23.4001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6581 26.0001C20.3178 26.0001 22.4739 24.254 22.4739 22.1001C22.4739 19.9462 20.3178 18.2001 17.6581 18.2001C14.9984 18.2001 12.8423 19.9462 12.8423 22.1001C12.8423 24.254 14.9984 26.0001 17.6581 26.0001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5004 16.9001C33.1601 16.9001 35.3162 15.154 35.3162 13.0001C35.3162 10.8462 33.1601 9.1001 30.5004 9.1001C27.8407 9.1001 25.6846 10.8462 25.6846 13.0001C25.6846 15.154 27.8407 16.9001 30.5004 16.9001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3422 23.4001C46.0019 23.4001 48.158 21.654 48.158 19.5001C48.158 17.3462 46.0019 15.6001 43.3422 15.6001C40.6825 15.6001 38.5264 17.3462 38.5264 19.5001C38.5264 21.654 40.6825 23.4001 43.3422 23.4001Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.184 7.8C58.8437 7.8 60.9998 6.05391 60.9998 3.9C60.9998 1.74609 58.8437 0 56.184 0C53.5243 0 51.3682 1.74609 51.3682 3.9C51.3682 6.05391 53.5243 7.8 56.184 7.8Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4553 2.47009C50.0842 6.63009 44.9474 12.8701 42.379 15.9901C40.4526 15.0801 37.4026 13.3901 32.1052 10.7901L30.0184 9.75009L16.6947 19.2401L5.45781 17.0301L3.85254 22.1001L18.2999 25.0901L30.6605 16.3801C34.8342 18.4601 39.9711 21.0601 41.0947 21.7101L41.8974 22.3601L43.3421 22.2301C45.1079 22.1001 45.1079 22.1001 58.5922 5.46009L53.4553 2.47009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendLine);
export default __webpack_public_path__ + "static/media/TrendLine.51ca5f09dbd1d81bc9d6d6779c765a70.svg";
export { ForwardRef as ReactComponent };